<template>
  <div class="line-clamp-2 w-46">
    {{ subIndustry }}
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

import { useIndustryOptions } from "@/hooks/options";

import type { IApplication } from "@/models/applications";
import type { PropType } from "vue";

const { subIndustryTypeLabel } = useIndustryOptions();

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: null,
  },
  model: {
    type: Object as PropType<IApplication>,
    default: null,
  },
});

const subIndustry = computed<string | null>(() =>
  subIndustryTypeLabel(
    Number(props.model.business?.industry_type_id),
    Number(props.model.business?.sub_industry_type_id)
  )
);
</script>
